import { Link } from "@tanstack/react-router";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import toMarkdown from "@sanity/block-content-to-markdown";
import MDXRemote from "#/components/MdxRemote";
import type { ArticleProps } from "#/types/types";
import type { PortableTextMarkDefinition } from "@portabletext/types";
import NavBar from "#/components/navbar/navbar";
import Footer from "#/components/footer/footer";

type Props = {
  data: Omit<ArticleProps, "body"> & {
    body: ArticleProps["body"] | string;
  };
};

export default function Article(props: Props) {
  const { title, body, slug, mainImage } = props.data;

  const serializers = {
    marks: {
      internalLink: ({
        mark,
        children,
      }: {
        mark: PortableTextMarkDefinition;
        children: string;
      }) => {
        const { slug = "" } = mark;
        const href = `/${slug as string}`;
        return `[${children}](${href})`;
      },
    },
  };

  const content =
    typeof body === "string"
      ? body
      : // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        (toMarkdown(body, { serializers }) as string);

  return (
    <>
      <header>
        <NavBar currentPath={"/" + slug} />
      </header>
      <main
        id="content"
        className="mx-auto mt-10 max-w-2xl space-y-5 text-gray-900"
      >
        <article className="mx-8">
          <header className="pb-5">
            <h1 className="mb-10 text-center text-5xl text-sky-600">{title}</h1>
            <PublishedBy />
          </header>

          {mainImage.url && (
            <figure className="mx-auto mb-10">
              <picture>
                <img
                  src={mainImage.url}
                  alt={mainImage.alt}
                  className="w-full rounded-lg object-cover object-center shadow-lg"
                  style={{ aspectRatio: "4 / 3" }}
                  width="800"
                  height="800"
                />
              </picture>

              <figcaption className="mt-4 text-center text-sm text-gray-500">
                {mainImage.caption}
              </figcaption>
            </figure>
          )}

          <MDXRemote source={content} />
        </article>
      </main>
      <Footer fmBio />
    </>
  );
}

const PublishedBy = () => {
  return (
    <div className="mb-5 mt-10 text-gray-500">
      <div className="flex items-center space-x-4">
        <img
          src="/frank-melo-md.png"
          alt="Frank Melo, MD"
          className="mx-auto rounded-full"
          width={60}
          height={60}
        />
        <div className="grow">
          <div>
            Published by{" "}
            <Link to="/about-roamdoc/frank-melo-md">
              <span>Frank Melo, MD</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
